import { AbstractDictionary } from "./AbstractDictionary";
export class DicDocumentType extends AbstractDictionary {
  static NAME = "tsadv$DicDocumentType";
  foreigner?: boolean | null;
  isIdOrPassport?: boolean | null;
}
export type DicDocumentTypeViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "dicDocumentType-browse"
  | "dicDocumentType-edit";
export type DicDocumentTypeView<
  V extends DicDocumentTypeViewName
> = V extends "_base"
  ? Pick<
      DicDocumentType,
      | "id"
      | "langValue"
      | "foreigner"
      | "isIdOrPassport"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicDocumentType,
      | "id"
      | "foreigner"
      | "isIdOrPassport"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<DicDocumentType, "id" | "langValue">
  : V extends "dicDocumentType-browse"
  ? Pick<
      DicDocumentType,
      | "id"
      | "foreigner"
      | "isIdOrPassport"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : V extends "dicDocumentType-edit"
  ? Pick<
      DicDocumentType,
      | "id"
      | "foreigner"
      | "isIdOrPassport"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : never;
